import React from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  RedAsterix,
  Select,
} from '@wegroup/design-system';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EmailCalculationFormValues } from './EmailCalculationModal';

interface Props {
  isExtended?: boolean;
}

const EmailCalculationModalFields: React.FC<Props> = ({ isExtended }) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext<EmailCalculationFormValues>();

  const genderOptions = [
    {
      label: t('MALE'),
      value: 'MALE',
    },
    {
      label: t('FEMALE'),
      value: 'FEMALE',
    },
    {
      label: t('GENDER_OTHER'),
      value: 'OTHER',
    },
  ];

  return (
    <>
      <FormControl isInvalid={!!errors.email}>
        <FormLabel>
          {t('EMAIL')} <RedAsterix />
        </FormLabel>
        <Input type="email" {...register('email')} />
        {errors.email?.message && (
          <FormErrorMessage>{t(errors.email.message)}</FormErrorMessage>
        )}
      </FormControl>
      {isExtended && (
        <>
          <FormControl isInvalid={!!errors.initials}>
            <FormLabel>{t('INITIALS')}</FormLabel>
            <Input {...register('initials')} />
            {errors.initials?.message && (
              <FormErrorMessage>{t(errors.initials.message)}</FormErrorMessage>
            )}
          </FormControl>
          <FormControl isInvalid={!!errors.last_name}>
            <FormLabel>{t('LAST-NAME')}</FormLabel>
            <Input {...register('last_name')} />
            {errors.last_name?.message && (
              <FormErrorMessage>{t(errors.last_name.message)}</FormErrorMessage>
            )}
          </FormControl>
          <FormControl isInvalid={!!errors.gender}>
            <FormLabel>{t('GENDER')}</FormLabel>
            <Select placeholder={t('CHOOSE_OPTION')} {...register('gender')}>
              {genderOptions.map(({ label, value }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </Select>
            {errors.gender?.message && (
              <FormErrorMessage>{t(errors.gender.message)}</FormErrorMessage>
            )}
          </FormControl>
        </>
      )}
    </>
  );
};

export default EmailCalculationModalFields;
